// extracted by mini-css-extract-plugin
module.exports = {"background":"Background_background_22Nts"};